var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-wrapper",attrs:{"id":'question-submission-' + _vm.interaction.id}},[_c('iframe',{key:_vm.iframeKey,ref:"qIframe",staticClass:"embedded-iframe",attrs:{"width":"100%","height":"100%","src":_vm.decodedUrl,"sandbox":"allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }